.tag {
  margin: 8px 4px;
  max-width: 200;
}

.resetButton {
  min-width: auto;
}

.filterWrapper {
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  border-top: 1px solid #ddd;
}
